import { legacyPlugins } from "/builds/sgdf/projets-benevoles/digiform/front/node_modules/.pnpm/@unhead+vue@3.4.0_@oxc-project+types@0.149.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_373bb1c12bfa7c4f2e55bafaeefe63d9/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}